import { computed, watch, WatchStopHandle } from 'vue';
import { CampaignType } from '@studyportals/campaign-management-api-interface';
import { ModalErrorStates } from '@/models/modal/modal.enum';
import { DispatchedEvents } from '@/models/dispatched-events.enum';
import campaignPresenter from '@/presenters/campaign-presenter';
import store from '@/store';

export default class EntitiesAndGeotargetingCode {
	private unwatch: WatchStopHandle | null = null;
	private boundUpdateCampaignReadinessInfoMethod = campaignPresenter.updateCampaignReadinessInfo.bind(campaignPresenter);

	public isCampaignTypeCustomProducts = computed((): boolean => {
		return this.campaignType.value === CampaignType.CUSTOM_PRODUCTS;
	});

	private campaignType = computed((): CampaignType | null => {
		return store.getters.campaignType();
	});

	public mounted(): void {
		// eslint-disable-next-line @typescript-eslint/no-misused-promises
		document.addEventListener(DispatchedEvents.GEOTARGETING_SAVED, this.boundUpdateCampaignReadinessInfoMethod);

		this.unwatch = watch(this.campaignType, this.ifCampaignIsCustomProductsOnlyTriggerError.bind(this));
	}

	public unmounted(): void {
		// eslint-disable-next-line @typescript-eslint/no-misused-promises
		document.removeEventListener(DispatchedEvents.GEOTARGETING_SAVED, this.boundUpdateCampaignReadinessInfoMethod);

		if (!this.unwatch) {
			return;
		}

		this.unwatch();
	}

	private ifCampaignIsCustomProductsOnlyTriggerError(): void {
		if (!this.isCampaignTypeCustomProducts.value) {
			return;
		}

		store.mutations.setModalErrorState(ModalErrorStates.CUSTOM_PRODUCTS_ONLY_CAMPAIGN_PAGE_VIEW);
	}
}
